export enum TripHomelandAllowanceDurationSource {
  HomelandPart = 0,
  AllParts = 1,
}
